import { render, staticRenderFns } from "./limitedEdition.vue?vue&type=template&id=2d3a35fb"
import script from "./limitedEdition.vue?vue&type=script&lang=js"
export * from "./limitedEdition.vue?vue&type=script&lang=js"
import style0 from "./limitedEdition.vue?vue&type=style&index=0&id=2d3a35fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports